import { DashStyleValue } from 'highcharts';

export const getThinDashedLineCrosshair = () => ({
  className: 'x-thin-crosshair',
  color: '#D8D8D8',
  width: 1.2,
  dashStyle: 'Solid' as DashStyleValue,
});
